import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core'
import { GbDashboardAuthService } from 'libs/gb-dashboard/account/utils/src/lib/gb-dashboard-auth-service/gb-dashboard-auth.service'
import { GbSetupGuideProgressService } from 'libs/gb-dashboard/setup-guide/utils/src/lib/gb-setup-guide-progress.service'
import { GbBreakpointService } from 'libs/gb-dashboard/shared/utils/src/lib/gb-breakpoint-service/gb-breakpoint.service'
import { combineLatest, map } from 'rxjs'

@Component({
  selector: 'gb-page-options-container',
  templateUrl: './gb-page-options-container.component.html',
  styleUrls: ['./gb-page-options-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GbPageOptionsContainerComponent implements AfterViewInit {
  @Input() alwaysCollapse: boolean = false
  @ViewChild('subOptions', { read: ElementRef }) subOptions?: ElementRef

  expanded = false
  hasSubOptions = false
  topOffset = 0

  showExpandedLayout$ = combineLatest([
    this.gbBreakpointService.desktopView$,
    this.setupGuideProgressService.setupGuideDrawerOpened$,
  ]).pipe(
    map(([desktopView, setupGuideDrawerOpened]) => {
      if (this.alwaysCollapse || setupGuideDrawerOpened) return false
      return desktopView
    }),
  )

  get livechatEnabled() {
    return !this.gbDashboardAuthService.isStaff()
  }

  get hiddenBanner(): Element | null {
    return document.querySelector('.auction-hidden-banner')
  }

  constructor(
    private gbBreakpointService: GbBreakpointService,
    private gbDashboardAuthService: GbDashboardAuthService,
    private setupGuideProgressService: GbSetupGuideProgressService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.setHasSubOptions()
    setTimeout(() => this.updateTopOffset())
  }

  setHasSubOptions(): void {
    this.hasSubOptions = this.subOptions?.nativeElement.hasChildNodes()
    this.cdr.detectChanges()
  }

  updateTopOffset(): void {
    this.topOffset = this.hiddenBanner?.clientHeight || 0
    this.cdr.detectChanges()
  }

  togglePageOptionsExpanded(): void {
    this.expanded = !this.expanded
    this.cdr.detectChanges()
  }

  getExpanded(): string {
    return this.expanded ? 'expanded' : 'collapsed'
  }

  @HostListener('window:resize')
  onWindowResize() {
    if (this.hiddenBanner) {
      this.updateTopOffset()
    }
  }
}
